import IncomingContractorsHeader from "./SubComponent/IncomingContractorsHeader";
import IncomingContractorsBody from "./SubComponent/IncomingContractorsBody";
import IncomingContractorsApp from "./Functionality/IncomingContractorsApp";
import CheckInModal from "./Modal/CheckInModal";
import CheckOutModal from "./Modal/CheckOutModal";
import LogModal from "./Modal/LogModal";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 26 de nov de 2025
 */


const IncomingContractors = () =>{
    const {
        isOnline,
        setIsReload,
        item,
        search,
        setSearch,
        t,
        withSearchActiveContractors,
        withSearchEmployeeInside,
        withSearchEmployeeOutside,
        withSearchEquipmentInside,
        withSearchEquipmentOutside,
        showCheckInModal,
        setShowCheckInModal,
        showCheckOutModal,
        setShowCheckOutModal,
        showLogModal,
        setShowLogModal,
        itemSelected,
        setItemSelected,
        outLog,
        setOutLog,
        handleChange,
        activeContractorsOptions
    } = IncomingContractorsApp()

    return (
        <>
            <IncomingContractorsHeader
                isOnline={isOnline}
                setIsReload={setIsReload}
                item={item}
                search={search}
                setSearch={setSearch}
                handleChange={handleChange}
                activeContractors={activeContractorsOptions}
            />
            <IncomingContractorsBody
                t={t}
                withSearchActiveContractors={withSearchActiveContractors}
                withSearchEmployeeInside={withSearchEmployeeInside}
                withSearchEmployeeOutside={withSearchEmployeeOutside}
                withSearchEquipmentInside={withSearchEquipmentInside}
                withSearchEquipmentOutside={withSearchEquipmentOutside}
                showCheckInModal={showCheckInModal}
                setShowCheckInModal={setShowCheckInModal}
                showCheckOutModal={showCheckOutModal}
                setShowCheckOutModal={setShowCheckOutModal}
                showLogModal={showLogModal}
                setShowLogModal={setShowLogModal}
                itemSelected={itemSelected}
                setItemSelected={setItemSelected}
                setOutLog={setOutLog}
            />

            {showCheckInModal &&
                <CheckInModal
                    show={showCheckInModal}
                    onHide={() => {
                        setShowCheckInModal(false);
                        setItemSelected(null);
                    }}
                    itemSelected={itemSelected}
                />
            }

            {showCheckOutModal &&
                <CheckOutModal
                    show={showCheckOutModal}
                    onHide={() => {
                        setShowCheckOutModal(false);
                        setItemSelected(null);
                    }}
                    itemSelected={itemSelected}
                />
            }

            { showLogModal &&
                <LogModal
                    show={showLogModal}
                    onHide={() => {
                        setShowLogModal(false);
                        setItemSelected(null);
                    }}
                    itemSelected={itemSelected}
                    out={outLog}
                />
            }

        </>
    )
}

export default IncomingContractors
